import { Button } from '@landingi/landingi-ui-kit'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

export const StartSubscriptionButton = ({
  onClick,
  isLoading,
  isDisabled
}: {
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  isLoading: boolean
  isDisabled: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={onClick}
      isDisabled={isLoading || isDisabled}
      isLoading={isLoading}
    >
      {t('change.plan.page.start.subscription.and.pay.now')}
    </Button>
  )
}

export const ChangePlanButton = ({
  onClick,
  isLoading,
  isDisabled
}: {
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  isLoading: boolean
  isDisabled: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={onClick}
      isDisabled={isLoading || isDisabled}
      isLoading={isLoading}
    >
      {t('change.plan.page.change.plan')}
    </Button>
  )
}

export const ChangeBillingCycleButton = ({
  onClick,
  isLoading,
  isDisabled
}: {
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  isLoading: boolean
  isDisabled: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={onClick}
      isDisabled={isLoading || isDisabled}
      isLoading={isLoading}
    >
      {t('change.plan.page.change.billing.cycle.button')}
    </Button>
  )
}

export const buttons = {
  startSubscription: StartSubscriptionButton,
  changeBillingCycle: ChangeBillingCycleButton,
  changePlan: ChangePlanButton
}
